import { useMutation } from "@apollo/client";
import { useCallback, useContext, useMemo, useState } from "react";
import { GlobalConfigContext } from "../context/GlobalConfigContext";
import { getStoreGroupsSummary } from "../graphql/queries/getStoreGroupsSummary";

export const useStoreGroupsSummary = () => {
  const { tagsData } = useContext(GlobalConfigContext);
  const [storeGroupsData, setStoreGroupsData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [executeFetch] = useMutation(getStoreGroupsSummary);

  const fetchStoreGroups = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await executeFetch({
        variables: { limit: 1000, offset: 0 },
      });
      setStoreGroupsData(result?.data?.getStoreGroupsSummary ?? null);
    } catch (error) {
      console.error("Failed to fetch store groups summary:", error);
    } finally {
      setIsLoading(false);
    }
  }, [executeFetch]);

  const storeGroups = useMemo(() => {
    const queryGroups = storeGroupsData?.items || [];
    const tagGroupNames = tagsData?.storeGroups || [];
    const queryGroupNames = queryGroups.map((item) => item.name);
    const mergedGroupNames = [...new Set([...tagGroupNames, ...queryGroupNames])];

    const queryByName = new Map(queryGroups.map((item) => [item.name, item]));

    return mergedGroupNames.map((name) => {
      const queryItem = queryByName.get(name);
      return {
        name,
        storeCount: queryItem?.amountOfStores ?? 0,
        zipCodes: queryItem?.zipCodes || [],
      };
    });
  }, [storeGroupsData, tagsData]);

  return { storeGroups, loading: isLoading, refetch: fetchStoreGroups };
};
